<template>
    <div id="cmswycshowbox" style="position: absolute; z-index: 10000; background-color: white; height: 150px; width: 320px; border: 1px solid rgb(27, 122, 222);">
        <p style="
		line-height: 30px;
		background-color: #0c7df5;
		color: white;
		font-size: 12px;
		padding-left: 10px;
		">
		<span>提示</span><span @click="showboxclose(3)" style="float: right;margin-top: 5px;margin-right: 5px;cursor: pointer;">
		<img src="https://aiplugin.5118.com/images/close.png">
		</span></p>
		<p style="vertical-align: middle;text-align: center;margin-top: 20px;
		line-height: 40px;font-size: 15px;">网络异常！请重新加载页面。</p>
		<p style="vertical-align: middle;text-align: center;font-size: 12px;color: gray;
		">温馨提示：重新加载前请先保存内容。</p>
		</div>
</template>
<script>
export default {
    methods:{
        showboxclose(jumptype){
            if(jumptype===3){
                this.$showboxmessage.addTarget(window.parent, 'parent');
                this.$showboxmessage.targets['parent'].send("Send_ShowBox_Close",3);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/ShowBoxError.vue